// extracted by mini-css-extract-plugin
export default {"form":"styles_form__rPMGJ","resend-wrapper":"styles_resend-wrapper__toatm","link":"styles_link__ZfiMc","buttons":"styles_buttons__UxKaz"};